module.exports = __webpack_public_path__ + "img/wolke_kumpel.eebf4aab.jpg";